"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fontFamily = `
@font-face {
  font-family: 'Ogg';
  src: url('/fonts/ogg/Ogg-Regular.woff'),
       url('/fonts/ogg/Ogg-Regular.woff2') format('woff2'),
       url('/fonts/ogg/Ogg-Regular.eot') format('eot'),
       url('/fonts/ogg/Ogg-Regular.otf') format('otf'),
       url('/fonts/ogg/Ogg-Regular.tff') format('tff');

  font-weight: 400;
  font-style: normal;
}

html {
    font-family: "Ogg", sans-serif;
}

`;
exports.default = {
    fontFamily,
};
